import { camelizeKeys } from 'fast-case';

export const camelcaseKeys = (
  obj: unknown,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  options?: { deep?: boolean }
): any => {
  // deep is already handled by fast-case
  return camelizeKeys(obj as any);
};
